import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cognitoAuth } from '../services/cognito';
import { theme } from '../styles/theme';

const API_URL = process.env.REACT_APP_API_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) { setError('Código de autenticação ausente.'); return; }

    // Evita dupla execução (React StrictMode)
    const usedKey = `oauth_used_${code.slice(-8)}`;
    if (sessionStorage.getItem(usedKey)) return;
    sessionStorage.setItem(usedKey, '1');
    window.history.replaceState({}, '', '/auth/callback');

    cognitoAuth.exchangeCodeForTokens(code)
      .then(async ({ idToken, user }) => {
        // Chama o backend que resolve tudo server-side
        const res = await fetch(`${API_URL}/auth/google-signin`, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ idToken })
        });

        if (!res.ok) throw new Error('Falha na autenticação');
        const data = await res.json();

        if (data.newUser) {
          // Novo usuário Google — vai para cadastro com email pré-preenchido
          navigate(`/register?email=${encodeURIComponent(data.email)}&name=${encodeURIComponent(data.name)}`, { replace: true });
          return;
        }

        // Usuário existente ou recém-vinculado
        const finalUser = {
          email:    data.email,
          name:     data.name,
          tenantId: data.tenantId,
          role:     data.role
        };
        localStorage.setItem('user', JSON.stringify(finalUser));
        redirectByRole(finalUser, navigate);
      })
      .catch(err => {
        console.error('AuthCallback error:', err);
        setError('Falha na autenticação. Tente novamente.');
      });
  }, []); // eslint-disable-line

  if (error) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16, background: theme.colors.gray900, color: 'white' }}>
      <div style={{ fontSize: 32 }}>❌</div>
      <div>{error}</div>
      <button onClick={() => navigate('/login')} style={{ padding: '8px 24px', borderRadius: 8, border: 'none', background: theme.colors.primary, color: 'white', cursor: 'pointer' }}>
        Voltar ao login
      </button>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: theme.colors.gray900, color: 'white', flexDirection: 'column', gap: 16 }}>
      <div style={{ width: 40, height: 40, border: '3px solid #6366f1', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      <div style={{ fontSize: 14, color: theme.colors.gray400 }}>Autenticando...</div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

function redirectByRole(user, navigate) {
  const { role, tenantId } = user;
  if (role === 'sallus_admin')  navigate('/sallus/dashboard', { replace: true });
  else if (role === 'manager')   navigate(`/manager/${tenantId}`, { replace: true });
  else if (role === 'agent')     navigate(`/callcenter/${tenantId}`, { replace: true });
  else if (tenantId)             navigate(`/dashboard/${tenantId}`, { replace: true });
  else                           navigate('/welcome', { replace: true });
}
